module.exports = __webpack_public_path__ + "static/img/processos.c15b3a6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/loja/processos.png
// module id = 837
// module chunks = 0